import { render, staticRenderFns } from "./AppPptxLogo.vue?vue&type=template&id=87425d42&scoped=true&"
import script from "./AppPptxLogo.vue?vue&type=script&lang=js&"
export * from "./AppPptxLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87425d42",
  null
  
)

export default component.exports